'use strict';

var boughtWithProducts = function () {

    var $boughtWithProductsContent = $('.boughtWithProductsContent');

    // Load div content with Ajax
    if ($boughtWithProductsContent.hasClass('async-load')) {
        $boughtWithProductsContent.asyncLoad(function __enableProductCarousel() {
            productTileSlick();
            updateQtyIncrementerButtonsState();
        });
    }
};

const stickyPdpActionBar = function () {
    let $pdpActionBtn;
    let elementTop;

    if (TINK.matchMediaMobileTablet()) {
        $pdpActionBtn = $('.pdp--pt-actions').first();
        elementTop = $pdpActionBtn.offset().top + 260;
    } else {
        $pdpActionBtn = $('.pi--additional-info');
        elementTop = $pdpActionBtn.offset().top + 75;
    }

    const $pdpActionBar = $('.actions-pdp-sticky');
    let screenHeight =  window.innerHeight;
    let viewportTop = 0;
    let actionPdpActive = 'actions-pdp--active';

    const changeStateOnScroll = function () {
        viewportTop = $(window).scrollTop() + screenHeight;
        if (elementTop < viewportTop) {
            $pdpActionBar.addClass(actionPdpActive);
        } else {
            $pdpActionBar.removeClass(actionPdpActive);
        }
    };

    changeStateOnScroll();
    $(window).on('scroll', _.throttle(changeStateOnScroll, 200));
}

const favoriteControl = function () {
    const $favoriteBtn = $('.productPDP .addToCartStarter, .pdp-top-visuals .addToCartStarter');
    let $otherFavoriteBtn = $favoriteBtn.not(this);

    if (isAuthenticated) {
        $favoriteBtn.on('click', function () {
            if ($(this).hasClass('is_favorite')) {
                $otherFavoriteBtn.removeClass('is_favorite is_active').attr('aria-expanded', false);
            } else {
                $otherFavoriteBtn.addClass('is_favorite is_active').attr('aria-expanded', true);
            }
        });
    }

}

const relocateProductLegal = function () {
    const legalContent = $('.pi--product-info--legal');
    if (legalContent.length) {
        var contentContainer = $('#content-temp');
        contentContainer.append(legalContent);
        legalContent.removeClass('hide');
    }
}

const bolderContainsInIngredients = function () {
    const $ingredientList = $('.pdp-ingredients-list');
    if($ingredientList.length){
        $ingredientList.html($ingredientList.html().replace(/(contient:|contient :|contient|peut contenir:|peut contenir :|peut contenir|contains:|contains :|contains|may contain:|may contain :|may contain)/ig, "<strong>$&</strong>"));
    }
};

const initBrandClickTracking = function (){
    $('.brandUrl').on('click', function () {
        pushDataLayerProductBrand($(this).data('product-brand'));
    });
};

jQuery(document).ready(function () {
    boughtWithProducts();
    stickyPdpActionBar();
    favoriteControl();
    relocateProductLegal()
    push_product_detail_metrics();
    bolderContainsInIngredients();
    initBrandClickTracking();
});

$(window).on('resize', _.throttle(stickyPdpActionBar, 500));
